import PricesScrollableList from 'components/Lists/ListView/PricesScrollableList';
import RestaurantsScrollableList from 'components/Lists/ListView/RestaurantsScrollableList';
import Text from 'components/Text/Text';
import React from 'react';
import { IItemDishesForPagination } from 'types';
import CategoriesScrollView from './components/CategoriesScrollView';
import SubCategoriesScrollView from './components/SubCategoriesScrollView';
import style from './MainInfoView.module.scss';

interface IMainInfoView {
	data: IItemDishesForPagination;
	isUnAssigned: boolean;
}

const MainInfoView: React.FC<IMainInfoView> = ({ data, isUnAssigned }) => {
	const hasCategories = !!data.categories.length;

	const restaurants = data.restaurantsDishes.map((el) => ({
		...el,
		id: el.restaurantId,
	}));

	const isDisabledInRestaurants = restaurants.filter((el) => el.isDisabled);

	return (
		<div className={style.infoContainer}>
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
				/>
				<Text className={style.blockValue} translationKey={data.name} withTooltip={true} />
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="articleNumberLabel"
					theme="neutralLight"
				/>
				<Text className={style.blockValue} translationKey={data.articleNumber} withTooltip={true} />
				{hasCategories && !isUnAssigned && (
					<Text
						className={style.blockName}
						translationNameSpace="listing"
						translationKey="categoryLabel"
						theme="neutralLight"
					/>
				)}
				{hasCategories && !isUnAssigned && (
					<div className={style.blockValue}>
						<CategoriesScrollView data={data.categories} />
					</div>
				)}
			</div>
			<div className={style.block}>
				{hasCategories && !isUnAssigned && (
					<Text
						className={style.blockName}
						translationNameSpace="listing"
						translationKey="subcategoryLabel"
						theme="neutralLight"
					/>
				)}
				{hasCategories && !isUnAssigned && (
					<div className={style.blockValue}>
						<SubCategoriesScrollView data={data.allSubCategories} />
					</div>
				)}
			</div>
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="restaurantWithPriceLabel"
					theme="neutralLight"
				/>
				<div className={style.blockValue}>
					<PricesScrollableList restaurants={restaurants} />
				</div>
			</div>
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="inStopLabel"
					theme="neutralLight"
				/>
				<div className={style.blockValue}>
					<RestaurantsScrollableList restaurants={isDisabledInRestaurants} />
				</div>
			</div>
		</div>
	);
};

export default React.memo(MainInfoView);
